class DetailsModal extends HTMLElement {
  constructor() {
    super();

    // Elements
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    // Close on ESC key
    this.detailsContainer.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.close();
    });

    // Toggle on summary click
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));

    // Close button inside modal
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    // Accessibility role
    this.summaryToggle.setAttribute('role', 'button');
  }

  // Check if modal is open
  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  // Handle summary click (toggle open/close)
  onSummaryClick(event) {
    event.preventDefault();
    const details = event.target.closest('details');
    details.hasAttribute('open') ? this.close() : this.open(event);
  }

  // Handle outside click to close
  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) {
      this.close(false);
    }
  }

  // Open modal
  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);

    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  // Close modal
  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);





const searchInput = document.querySelector('.header-search-form input');
const searchForm = document.querySelector('.header-search-form');

searchInput?.addEventListener('focus', () => {
  searchForm.classList.add('expanded');
});
searchInput?.addEventListener('blur', () => {
  searchForm.classList.remove('expanded');
});